/**
 * Remove o trecho "(SQL: ...)" típico de erros Laravel/MySQL para análise e exibição.
 */
function stripSqlQueryTail(message: string): string {
  const idx = message.search(/\s*\(SQL:/i);
  if (idx !== -1) return message.slice(0, idx).trim();
  return message;
}

/** Tabelas filhas comuns → texto para o usuário (PT-BR) */
const FK_CHILD_TABLE_HINTS: Record<string, string> = {
  pacotes: 'pacotes',
  invoices: 'faturas',
  invoice_items: 'itens de fatura',
  caixas: 'caixas ou malas',
  boxes: 'caixas ou malas',
  envios: 'envios',
  documentos: 'documentos',
  coletas: 'coletas',
  fornecedores: 'dados de fornecedores',
};

/**
 * Converte mensagens cruas de violação de FK / integridade em texto adequado para notificação.
 * Caso não reconheça o padrão, devolve a mensagem já sem o trecho gigante de SQL quando possível.
 */
export function humanizeForeignKeyDeleteError(
  rawMessage: string,
  resourcePhrase = 'este registro'
): string {
  let msg = (rawMessage || '').trim();
  if (!msg) {
    return 'Não foi possível concluir a exclusão. Tente novamente.';
  }

  msg = stripSqlQueryTail(msg);

  const isFkParentDeleteBlock =
    /SQLSTATE\[23000\]/i.test(msg) ||
    /Integrity constraint violation/i.test(msg) ||
    /Cannot delete or update a parent row/i.test(msg) ||
    /foreign key constraint fails/i.test(msg);

  if (isFkParentDeleteBlock) {
    const childMatch = msg.match(
      /foreign key constraint fails\s*\(\s*`[^`]*`\s*\.\s*`([^`]+)`/i
    );
    const table = (childMatch?.[1] || '').toLowerCase();

    const detail = table
      ? FK_CHILD_TABLE_HINTS[table] ?? `registros em “${table}”`
      : 'registros relacionados';

    return `Não é possível excluir ${resourcePhrase}: ainda existem ${detail} vinculados. Remova ou transfira esses vínculos antes de excluir.`;
  }

  // Mensagem longa com lixo técnico: evita flood na UI
  if (msg.length > 400 && /SQLSTATE|Integrity constraint|FOREIGN KEY/i.test(msg)) {
    return `Não é possível excluir ${resourcePhrase} por restrições no banco de dados. Verifique vínculos com outros registros e tente novamente.`;
  }

  return msg;
}
